export default {
    active_requirement_orders: "Активные наряд-заказы",
    add_laboratory_service: "Добавить лабораторную услугу",
    after_finished_fixed: "По факту проведения",
    can_have_dental_work: "Может содержать зуботехнические работы",
    cannot_change_services_that_already_have_laboratory_services_attached: "Нельзя удалить услуги, к которым уже привязаны лабораторные работы из наряд-заказа",
    carcass: "Каркас",
    deleted_from_treatment: "Удалено из лечения",
    delivery_date: "Дата сдачи",
    dental_work: "Зуботехнические работы",
    do_you_confirm_cancel_laboratory_order: "Вы действительно хотите отменить наряд-заказ?",
    do_you_confirm_laboratory_order_finish: "Вы подтверждаете, что работа пациенту сдана? После подтверждения, будет начислена зарплата доктору, а изменения по данному наряд-заказу будут невозможны.",
    do_you_confirm_laboratory_order_finish2: "Вы подтверждаете, что работа пациенту сдана? В проведенный наряд-заказ невозможно внести изменения. Для редактирования потребуется отмена проведения документа.",
    executor: "Исполнитель",
    faintly: "Слабо",
    field_is_required: "Поле обязательно",
    fitting_date: "Дата примерки",
    full: "Полный",
    immediately: "Сразу",
    in_clinic: "В клинике",
    in_lab: "В лаборатории",
    initiated: "Инициирован",
    intermediate_part_design: "Дизайн промежуточной части",
    laboratories: "Лаборатории",
    laboratory: "Лаборатория",
    laboratory_service: "Лабораторная услуга",
    LaboratoryOrder: "Наряд-заказ",
    logics_on_laboratory_services_deduction: "Логика вычитания лабораторных работ по наряд-заказу",
    moderately: "Умеренно",
    must_have_dental_work: "Обязательно содержит зуботехнические работы",
    no_dental_work_needed_for_selected_services: "Для выбранных услуг зуботехнические работы не требуются",
    no_services: "Нет услуг",
    order_number: "Номер наряда",
    paint_restorations: "Окрасить реставрации",
    panorama: "Панорама",
    pay_all: "Оплатить все",
    requirement_order: "Наряд - заказ",
    select_from_price: "Выбрать из прайса",
    send_to_laboratory_via_messenger: "Отправить лаборатории через мессенджер",
    shoulder: "Плечо",
    simplified: "Упрощенный",
    total_orders_for_the_amount: "Всего нарядов на сумму",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "При смене лаборатории все выбранные услуги будут удалены из списка. Продолжить?",
    without_attachment_to_tooth: "Без привязки к зубу"
}
